module.exports = __webpack_public_path__ + "static/media/Tungsten-Bold.a343427d.otf";